/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Text_TitleInputs */

const en_mcp_demo_text_title = /** @type {(inputs: Mcp_Demo_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q3 planning notes`)
};

const es_mcp_demo_text_title = /** @type {(inputs: Mcp_Demo_Text_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de planificación del T3`)
};

/**
* | output |
* | --- |
* | "Q3 planning notes" |
*
* @param {Mcp_Demo_Text_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_text_title = /** @type {((inputs?: Mcp_Demo_Text_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Text_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_text_title(inputs)
	return en_mcp_demo_text_title(inputs)
});